import React, { useMemo } from 'react'

import { useFilters, useModals, useSetState } from '@domain-group/react-hooks'

import { ModalContext } from '@domain-group/suit-theme'

import PageContext from '@contexts/pageContext'

import handleCallbackAction from '@functions/handleCallbackAction'

import CreateOrEditFontFamilyModal from '@modals/CreateOrEditFontFamilyModal'
import CreateOrEditFontModal from '@modals/CreateOrEditFontModal'

import PageContent from './components/PageContent'

const callbacks = (component, setState) => {
  const componentCallbacks = {
    CreateOrEditFontFamilyModal: {
      closeModal: () => setState({ showCreateOrEditFontFamilyModal: false }),
      createFontFamily: payload => handleCallbackAction(payload),
      deleteFont: payload => handleCallbackAction(payload),
      updateFontFamily: payload => handleCallbackAction(payload),
    },
    CreateOrEditFontModal: {
      closeModal: () => setState({ showCreateOrEditFontModal: false }),
      createFont: payload => handleCallbackAction(payload),
      deleteFont: payload => handleCallbackAction(payload),
      updateFont: payload => handleCallbackAction(payload),
    },
  }

  return componentCallbacks[component] || {}
}

const defaultState = {
  showCreateOrEditFontFamilyModal: false,
  showCreateOrEditFontModal: false,
}

const List = () => {
  const [state, setState] = useSetState(defaultState)
  const { showCreateOrEditFontFamilyModal, showCreateOrEditFontModal } = state

  const {
    callbacks: filterCallbacks,
    defaultFilters,
    pageFilters,
  } = useFilters()

  const modalContext = useModals({ setState })
  const {
    callbacks: { setModalData },
    topModalKey,
  } = modalContext

  const pageContext = useMemo(() => ({
    callbacks: {
      ...filterCallbacks,
      showCreateOrEditFontFamilyModal: (payload) => {
        setModalData('CreateOrEditFontFamilyModal', payload)
        setState({ showCreateOrEditFontFamilyModal: true })
      },
      showCreateOrEditFontModal: (payload) => {
        setModalData('CreateOrEditFontModal', payload)
        setState({ showCreateOrEditFontModal: true })
      },
    },
    defaultFilters,
  }), [topModalKey])

  return (
    <PageContext.Provider value={pageContext}>
      <ModalContext.Provider value={modalContext}>
        <PageContent pageFilters={pageFilters} />

        <CreateOrEditFontFamilyModal
          callbacks={callbacks('CreateOrEditFontFamilyModal', setState)}
          showModal={showCreateOrEditFontFamilyModal}
        />

        <CreateOrEditFontModal
          callbacks={callbacks('CreateOrEditFontModal', setState)}
          showModal={showCreateOrEditFontModal}
        />
      </ModalContext.Provider>
    </PageContext.Provider>
  )
}

export default List
